import React from "react";
import { View, Text, StyleSheet, TouchableOpacity, ScrollView } from "react-native";
import { format, addDays, isSameDay } from "date-fns";
import { useTheme } from "../../../context/ThemeContext";

const CalendarView = ({ selectedDate, onDateSelect, events = [] }) => {
	const theme = useTheme();
	const styles = useStyles();

	// Generate next 30 days
	const dates = Array.from({ length: 30 }, (_, i) => addDays(new Date(), i));

	const hasEvents = (date) => events.some((event) => isSameDay(new Date(event.date), date));

	const renderDateItem = (date) => {
		const isSelected = isSameDay(date, selectedDate);
		const hasEventOnDate = hasEvents(date);

		return (
			<TouchableOpacity key={date.toISOString()} style={[styles.dateItem, isSelected && styles.selectedDateItem]} onPress={() => onDateSelect(date)}>
				<Text style={[styles.dayName, isSelected && styles.selectedText]}>{format(date, "EEE")}</Text>
				<Text style={[styles.dayNumber, isSelected && styles.selectedText]}>{format(date, "d")}</Text>
				{hasEventOnDate && <View style={[styles.eventDot, isSelected && styles.selectedEventDot]} />}
			</TouchableOpacity>
		);
	};

	return (
		<View style={styles.container}>
			<ScrollView horizontal showsHorizontalScrollIndicator={false} style={styles.scrollView}>
				<View style={styles.datesContainer}>{dates.map(renderDateItem)}</View>
			</ScrollView>
		</View>
	);
};

const useStyles = () => {
	const theme = useTheme();

	return StyleSheet.create({
		container: {
			backgroundColor: theme.colors.systemBackground.primary,
		},
		scrollView: {
			paddingVertical: theme.spacing.sm,
		},
		datesContainer: {
			flexDirection: "row",
			paddingHorizontal: theme.spacing.sm,
			gap: theme.spacing.sm,
		},
		dateItem: {
			alignItems: "center",
			justifyContent: "center",
			paddingVertical: theme.spacing.sm,
			paddingHorizontal: theme.spacing.md,
			borderRadius: theme.borderRadius.lg,
			backgroundColor: theme.colors.systemBackground.secondary,
		},
		selectedDateItem: {
			backgroundColor: theme.colors.primary,
		},
		dayName: {
			...theme.typography.caption2,
			color: theme.colors.textSecondary,
			marginBottom: theme.spacing.xs,
		},
		dayNumber: {
			...theme.typography.headline,
			color: theme.colors.text,
		},
		selectedText: {
			color: theme.colors.systemBackground.primary,
			fontWeight: "600",
		},
		eventDot: {
			width: 6,
			height: 6,
			borderRadius: 2,
			backgroundColor: theme.colors.primary,
			marginTop: theme.spacing.xs,
		},
		selectedEventDot: {
			backgroundColor: theme.colors.systemBackground.primary,
		},
	});
};

export default CalendarView;
